import { showErrorDialog } from '@juvare/common-web-ui/DialogHelper';
import { Box, Button, Typography } from '@mui/material';
import React from 'react';
export const SelectFileArea = (props) => {
    const [dragStatus, setDragStatus] = React.useState();
    const file = React.useRef(null);
    const { onSelectFile } = props;
    const processFile = React.useCallback((file) => {
        onSelectFile(file);
    }, [onSelectFile]);
    const handleDrop = React.useCallback((event) => {
        event.preventDefault();
        setDragStatus(undefined);
        const file = findValidFileInDragEvent(event, props.fileInputAccept);
        if (file) {
            processFile(file);
        }
        else {
            showErrorDialog({
                title: 'Not a ' + props.fileTypeLabel + ' selected',
                onClose: () => undefined,
            });
        }
    }, [processFile, props.fileTypeLabel, props.fileInputAccept]);
    const handleDragOver = React.useCallback((event) => event.preventDefault(), []);
    const handleDragEnter = React.useCallback((event) => {
        event.preventDefault();
        setDragStatus(isValidFileInDragEvent(event) ? 'valid' : 'invalid');
    }, []);
    const handleDragLeave = React.useCallback((event) => {
        event.preventDefault();
        setDragStatus(undefined);
    }, []);
    const handleFileChange = React.useCallback((event) => {
        if (event.target.files) {
            for (let i = 0; i < event.target.files.length; i++) {
                const file = event.target.files[i];
                if (file) {
                    if (file.name.toLowerCase().endsWith(props.fileInputAccept)) {
                        processFile(file);
                    }
                    else {
                        showErrorDialog({
                            title: 'Not a ' + props.fileTypeLabel + ' selected',
                            onClose: () => undefined,
                        });
                    }
                    return;
                }
            }
        }
    }, [processFile, props.fileTypeLabel, props.fileInputAccept]);
    const handleSelectFileClick = React.useCallback(() => {
        if (file.current) {
            file.current.click();
        }
    }, []);
    if (props.file) {
        return (React.createElement(Box, { sx: {
                boxSizing: 'border-box',
                width: '100%',
                height: 160,
                padding: (theme) => theme.spacing(1),
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                border: '4px dashed rgba(0, 0, 0, 0.4)',
            } },
            React.createElement(Typography, null,
                "Selected file ",
                props.file.name)));
    }
    else {
        return (React.createElement(Box, { sx: {
                boxSizing: 'border-box',
                width: '100%',
                height: 160,
                padding: (theme) => theme.spacing(1),
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                border: '4px dashed rgba(0, 0, 0, 0.4)',
            }, onDrop: handleDrop, onDragOver: handleDragOver, onDragEnter: handleDragEnter, onDragLeave: handleDragLeave, onDragStart: handleDragEnter, onDragEnd: handleDragLeave },
            dragStatus === 'valid' && React.createElement(Typography, { sx: { pointerEvents: 'none' } },
                "Drop ",
                props.fileTypeLabel,
                " here..."),
            dragStatus === 'invalid' && React.createElement(Typography, { sx: { pointerEvents: 'none' } },
                "Not a ",
                props.fileTypeLabel),
            !dragStatus && (React.createElement(React.Fragment, null,
                React.createElement(Typography, null,
                    "Drop ",
                    props.fileTypeLabel,
                    " here..."),
                React.createElement(Typography, null, "or"),
                React.createElement("input", { ref: file, type: 'file', hidden: true, accept: props.fileInputAccept, onChange: handleFileChange }),
                React.createElement(Button, { variant: 'outlined', color: 'primary', onClick: handleSelectFileClick },
                    "Select ",
                    props.fileTypeLabel)))));
    }
};
function isValidFileInDragEvent(event) {
    if (event.dataTransfer.items) {
        // Use DataTransferItemList interface to access the file(s)
        for (let i = 0; i < event.dataTransfer.items.length; i++) {
            // If dropped items aren't files, reject them
            if (event.dataTransfer.items[i].kind === 'file') {
                const file = event.dataTransfer.items[i];
                if (file) {
                    return true;
                }
            }
        }
    }
    else if (event.dataTransfer) {
        // Use DataTransfer interface to access the file(s)
        for (let i = 0; i < event.dataTransfer.files.length; i++) {
            const file = event.dataTransfer.files[i];
            if (file) {
                return true;
            }
        }
    }
    return false;
}
function findValidFileInDragEvent(event, fileInputAccept) {
    if (event.dataTransfer.items) {
        // Use DataTransferItemList interface to access the file(s)
        for (let i = 0; i < event.dataTransfer.items.length; i++) {
            // If dropped items aren't files, reject them
            if (event.dataTransfer.items[i].kind === 'file') {
                const file = event.dataTransfer.items[i].getAsFile();
                if (file && file.name.toLowerCase().endsWith(fileInputAccept)) {
                    return file;
                }
            }
        }
    }
    else if (event.dataTransfer) {
        // Use DataTransfer interface to access the file(s)
        for (let i = 0; i < event.dataTransfer.files.length; i++) {
            const file = event.dataTransfer.files[i];
            if (file && file.name.toLowerCase().endsWith(fileInputAccept)) {
                return file;
            }
        }
    }
    return undefined;
}
